import styled from 'styled-components';

export const Separator = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 1px;
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};
  height: 12px;
  margin-left: 8px;
  margin-right: 8px;
`;

export const DebugInfoBlock = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

export const DebugInfoLabel = styled.div`
  display: inline-block;
  vertical-align: middle;
  color: ${({ theme }) => theme.kallisto.color.common.white[600]};
  ${({ theme }) => theme.kallisto.mixins.font('BodySmall')};
`;

export const DebugInfoValue = styled.div`
  display: inline-block;
  vertical-align: middle;
  color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};
  ${({ theme }) => theme.kallisto.mixins.font('BodySmall')};
`;
